module.exports = __webpack_public_path__ + "img/7C584C_27140D_B3765C_3D2318-256px.d6f9ebe0.png";